import { Link } from "react-router-dom";
import { ShieldCheck, ArrowLeft } from "lucide-react";

const SECTIONS = [
  {
    title: "1. Responsable du traitement",
    body: "Direction Santé & Sécurité — Lafarge Ciments France (Groupe Holcim). Contact : khalifa.belkhiter@lafarge.com.",
  },
  {
    title: "2. Données collectées",
    body: "Données de compte (nom, email professionnel, rôle, site de rattachement) via connexion Google professionnelle ; données d'audit (réponses, constats, scores, commentaires) ; photos et preuves prises sur le terrain ; historique des actions correctives.",
  },
  {
    title: "3. Finalités du traitement",
    body: "Réalisation et suivi des audits croisés World Class Energy Isolation, pilotage de la sécurité énergétique des sites, génération de rapports et de tableaux de bord de la Direction Santé & Sécurité, traçabilité des actions correctives.",
  },
  {
    title: "4. Base légale",
    body: "Intérêt légitime de l'employeur en matière de santé, sécurité au travail et prévention des risques industriels, dans le cadre du référentiel Groupe Holcim.",
  },
  {
    title: "5. Hébergement & destinataires",
    body: "Les données métier (audits, actions) sont stockées exclusivement dans un espace Google Sheets/Google Drive dédié, accessible uniquement via un compte de service sécurisé, sans transfert à des tiers hors Groupe Holcim. Les données de session (technique) sont hébergées sur l'infrastructure Emergent.",
  },
  {
    title: "6. Durée de conservation",
    body: "Conformément au référentiel Holcim HSE-103 : les dossiers d'isolation énergétique sont conservés au minimum 60 mois, les permis de travail au minimum 6 mois. Les données de compte sont conservées pendant la durée d'activité de l'utilisateur sur le périmètre concerné, plus 3 ans.",
  },
  {
    title: "7. Vos droits",
    body: "Conformément au RGPD (Règlement UE 2016/679), vous disposez d'un droit d'accès, de rectification, d'effacement, de limitation, d'opposition et de portabilité de vos données. Pour exercer ces droits, contactez le Responsable du traitement mentionné ci-dessus.",
  },
  {
    title: "8. Sécurité",
    body: "Accès à l'application soumis à authentification Google professionnelle, contrôle d'accès par rôle (ADMIN, AUDITEUR, RESPONSABLE_SITE, DIRECTION_SECURITE, LECTEUR), communications chiffrées (HTTPS), aucune clé de service exposée côté client.",
  },
  {
    title: "9. Cookies & stockage local",
    body: "L'application utilise uniquement un jeton de session technique nécessaire à l'authentification, ainsi qu'un stockage local (localStorage) pour la préférence de langue et le suivi du tutoriel d'accueil. Aucun cookie publicitaire ou de traçage tiers n'est utilisé.",
  },
];

export default function PolitiqueConfidentialite() {
  return (
    <div className="p-4 sm:p-6 max-w-2xl mx-auto space-y-6" data-testid="privacy-policy-page">
      <Link to="/aide" data-testid="privacy-back-link" className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground">
        <ArrowLeft className="h-4 w-4" /> Retour à l'aide
      </Link>

      <div className="flex items-center gap-3">
        <div className="p-2.5 rounded-xl bg-emerald-100 dark:bg-emerald-900/30">
          <ShieldCheck className="h-6 w-6 text-emerald-600 dark:text-emerald-400" />
        </div>
        <div>
          <h1 className="font-heading text-2xl sm:text-3xl font-black uppercase tracking-tight">Politique de Confidentialité</h1>
          <p className="text-sm text-muted-foreground">World Class Energy Isolation Assessment — RGPD</p>
        </div>
      </div>

      <div className="space-y-4">
        {SECTIONS.map((s, i) => (
          <div key={i} data-testid={`privacy-section-${i}`} className="rounded-xl border border-border bg-card p-4">
            <h2 className="font-semibold text-sm mb-1.5">{s.title}</h2>
            <p className="text-sm text-muted-foreground leading-relaxed">{s.body}</p>
          </div>
        ))}
      </div>

      <p className="text-xs text-muted-foreground text-center pt-2">Dernière mise à jour : Septembre 2026 — Document type, à personnaliser par la Direction Juridique Lafarge Ciments France.</p>
    </div>
  );
}
